module.exports = __webpack_public_path__ + "static/img/1.075bd9b5.png";